export default "__VITE_ASSET__DWhtdPMn__"